import React from "react";
import { Box, useMediaQuery } from "@mui/material";
import Navbar from "./navbar";
import "./layout.css";
import Sidebar from "./sidebar";
import ClosingDealAlert from "../components/customers/deals/ClosingDealAlert";

const NAVBAR_HEIGHT = 64;
const SIDEBAR_OPEN_WIDTH = 250;
const SIDEBAR_COLLAPSED_WIDTH = 72;

const MainLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const isMobile = useMediaQuery("(max-width:768px)");
  const [sidebarWidth, setSidebarWidth] = React.useState<number>(SIDEBAR_OPEN_WIDTH);
  const [mobileOpen, setMobileOpen] = React.useState<boolean>(false);

  const handleToggle = (isOpen: boolean) => {
    setSidebarWidth(isOpen ? SIDEBAR_OPEN_WIDTH : SIDEBAR_COLLAPSED_WIDTH);
  };

  const handleMobileToggle = (open: boolean) => {
    setMobileOpen(open);
  };

  const resolvedSidebarWidth = isMobile ? (mobileOpen ? SIDEBAR_OPEN_WIDTH : 0) : sidebarWidth;

  return (
    <Box sx={{ display: "flex", height: "100vh", overflow: "hidden", bgcolor: "#fafafbff" }}>
      {/* Fixed Sidebar */}
      <Box
        sx={{
          width: resolvedSidebarWidth,
          position: "fixed",
          top: 0,
          left: 0,
          bottom: 0,
          bgcolor: "#151824",
          zIndex: 1200,
          overflow: "hidden",
          transition: "width 0.2s",
        }}
      >
        <Sidebar
          openToggle={handleToggle}
          mobileOpen={mobileOpen}
          mobileToggle={handleMobileToggle}
        />
      </Box>
      <Box
        sx={{
          // On mobile: do NOT shift content; sidebar overlays
          marginLeft: isMobile ? 0 : `${sidebarWidth}px`,
          width: isMobile ? "100%" : `calc(100% - ${sidebarWidth}px)`,
          display: "flex",
          flexDirection: "column",
          height: "100vh",
        }}
      >
        {/* Fixed Navbar */}
        <Box
          sx={{
            height: `${NAVBAR_HEIGHT}px`,
            position: "fixed",
            top: 0,
            left: isMobile ? 0 : `${sidebarWidth}px`,
            right: 0,
            zIndex: 1100,
            bgcolor: "background.paper",
          }}
        >
          <Navbar onMobileToggle={handleMobileToggle} mobileOpen={mobileOpen} />
        </Box>

        {/* Scrollable Content */}
        <Box
          className="layout-main-bg"
          sx={{
            flex: 1,
            marginTop: `${NAVBAR_HEIGHT}px`,
            overflowY: "auto",
            p: 3,
            height: `calc(100vh - ${NAVBAR_HEIGHT}px)`,
            backgroundColor: "#f9f9f9",
          }}
        >
          {children}
        </Box>
      </Box>
      <ClosingDealAlert />
    </Box>
  );
};

export default MainLayout;
